import { Component, OnInit } from '@angular/core';
import {AidantRelation, Patient, Word} from '../_models';
import {AidantService, PatientService} from '../_services';
import {first} from 'rxjs/operators';
import * as moment from 'moment';
import {Aidant} from '../../../src/app/_models';
import {Router} from '@angular/router';
import {getCurrentAbeille, getCurrentRole} from '../../assets/utils.js';
import {WordService} from '../_services/word.service';


@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

    ready = false;
    patientId = '';
    patient: Patient;
    aidants: Aidant[];
    wordsCount = 0;
    showModal = false;
    editMascotte = false;
    selectedMascotte = 1;

    constructor(private router: Router,
                private aidantService: AidantService,
                private patientService: PatientService,
                private wordService: WordService) {

        if (window.innerWidth < 700) { //if phone, redirect to lexibox
            this.router.navigate(['/lexibox']);
        }

        if (!getCurrentAbeille()) {
            this.router.navigate(['/dashboard']);
        }

        this.patientId = getCurrentAbeille().id;
    }

    ngOnInit() {
        this.refreshPatient();
    }

    ngAfterViewChecked() {
        setTimeout(() => this.ready = true, 600);
    }

    public refreshPatient() {

        this.patientService.getById(this.patientId).pipe(first()).subscribe(patient => {
            this.patient = new Patient(patient);
            this.selectedMascotte = this.patient.idAvatar;

            this.wordService.getByPatientId(this.patientId).pipe(first()).subscribe(words => {
                this.wordsCount = (words as Word[]).length;

            });
        });

        this.aidantService.getByPatientId(this.patientId).pipe(first()).subscribe(aidants => {
            this.aidants = aidants as Aidant[];
        });


        this.showModal = false;
    }

    selectMascotte(id) {
        this.selectedMascotte = id;
    }

    toggleMascotte() {
        this.editMascotte =  true;
    }

    updateMascotte() {

        let patient = new Patient(this.patient);
        patient.idAvatar = this.selectedMascotte;

        this.patientService.update(patient).pipe(first()).subscribe(result => {
            this.editMascotte = false;
            this.refreshPatient();

        });
    }
}
